import React, { useEffect, useState } from 'react';
import '../../styles.css';
import LetterCard from './LetterCard.js';
import Grid from '@material-ui/core/Grid';
import TenAttemptsRow from '../students/TenAttemptsRow.js';
import { firestore } from '../../Firebase';
// It is currently difficult to add more levels in as you will need to do manually retrieve and sort each dataset
// Need to find a way to automate this by snapshotting the full dataset
function LetterCardMatrix(props) {
    const [smt_data, setSMTData] = useState("")
    const [pnc_data, setPNCData] = useState("")
    const [krb_data, setKRBData] = useState("")
    const [jfg_data, setJFGData] = useState("")
    const [hdw_data, setHDWData] = useState("")
    const [vly_data, setVLYData] = useState("")
    const [last_8, setLast8] = useState("")

    useEffect(() => {
        const unsub = firestore.collection('accounts')
            .where('username', '==', props.username)
            .where("name", '==', props.name)
            .onSnapshot(snap => {
                setSMTData(snap.docs.map((doc) => doc.data()["smt"])[0])
                setPNCData(snap.docs.map((doc) => doc.data()["pnc"])[0])
                setKRBData(snap.docs.map((doc) => doc.data()["krb"])[0])
                setJFGData(snap.docs.map((doc) => doc.data()["jfg"])[0])
                setHDWData(snap.docs.map((doc) => doc.data()["hdw"])[0])
                setVLYData(snap.docs.map((doc) => doc.data()["vly"])[0])
                setLast8(snap.docs.map((doc) => doc.data()["last_8"])[0])
            });
        return () => {
            unsub();
        }
    }, [])

    function findHighestStreak(data) {
        var current_streak = 0
        var max_streak = 0;
        for (var i = 1; i < data.length; i += 2) {
            if (data[i] === 'correct') {
                current_streak += 1
                if (current_streak > max_streak) {
                    max_streak = current_streak
                }
            }
            else {
                current_streak = 0
            }
        }
        return max_streak
    }

    var max_streaks = [
        findHighestStreak(smt_data),
        findHighestStreak(pnc_data),
        findHighestStreak(krb_data),
        findHighestStreak(jfg_data),
        findHighestStreak(hdw_data),
        findHighestStreak(vly_data)
    ]
    const letters = [
        'smt',
        'pnc',
        'krb',
        'jfg',
        'hdw',
        'vly'
    ];



    var cards = []
    for (let i = 0; i < letters.length; i++) {
        cards[i] = <Grid key={i} item><LetterCard letter={letters[i]} percentage={max_streaks[i]} /></Grid>
    }

    return (
        <div>
            <p className='studentProgressNameText'>{props.name}</p>
            <p className='attemptCaptionForStudentProgress' style={{ fontFamily: 'chalkboard' }}>Last Level Attempt:</p>
            <div className='tenAttemptRowForStudentProgress'><TenAttemptsRow values={last_8} /></div>
            <p className='attemptCaptionForStudentProgress' style={{ fontFamily: 'chalkboard', marginTop: 30 }}>Longest Streaks:</p>
            <div className='column'>
                <Grid container spacing={5} style={{ width: '70%' }}>
                    {cards}
                </Grid>
            </div>
        </div>
    );
}

export default LetterCardMatrix;